<template>
  <v-dialog v-model="$store.state.badge.dialog" scrollable persistent max-width="800px">
    <div>
      <v-card>
        <v-toolbar color="secondary" dense dark>
          <v-spacer></v-spacer>
          <v-card-title primary-title> Add Badge </v-card-title>
          <v-spacer></v-spacer>
          <v-btn dark icon left @click="$store.state.badge.dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-container fluid>
          <v-card-text>
            <v-form ref="form" lazy-validation>

              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-combobox v-model="item.TerminalID" :items="terminals" :item-text="'Status'" :item-value="'id'"
                      auto-select-first label="Terminal" :rules="[v => !!v || 'Item is required']" required></v-combobox>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field label="Badge Number" v-model="item.BadgeNumber" type="number" required></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field label="Creation Date" v-model="item.CreationDate"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field label="Orientation Expiry Date" v-model="item.OrientationExpDate"
                      :placeholder="$store.state.placeholder" hint="Defaults to +5 years from today." v-mask="$store.state.mask"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="2">
                    <v-checkbox :label="item.IsPermittedToUnload ? 'Unload' : 'Load'" v-model="item.IsPermittedToUnload" color="secondary">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox :label="item.IsActive ? 'Active' : 'Inactive'" v-model="item.IsActive" color="secondary">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea outlined placeholder="..." auto-grow label="Comments"
                      v-model="item.Comments"></v-textarea>
                  </v-col>
                </v-row>
                <v-row justify="end">
                  <v-btn small @click="validate" color="secondary">Save</v-btn>
                </v-row>
              </v-container>

            </v-form>
          </v-card-text>
        </v-container>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
  directives: { mask },
  props: ['drvID', 'terms'],
  data: function () {
    return {
      item: {
        TerminalID: '',
        BadgeNumber: '',
        //Set Creation date to today with format YYYY-MM-DD
        CreationDate: new Date().toISOString().substr(0, 10),
        //Set Orientation expiry date to 5 years from today with format YYYY-MM-DD
        OrientationExpDate: new Date(new Date().setFullYear(new Date().getFullYear() + 5)).toISOString().substr(0, 10),
        IsPermittedToUnload: 0,
        IsActive: 1,
        LockedOut: 0,
        Comments: ''
      },
      terminals: []
    };
  },
  mounted() {
    this.loadTerminals(this.terms);
  },
  methods: {
    newBadges: function () {
      var parms = {
        TerminalID: this.item.TerminalID.id,
        BadgeNumber: this.item.BadgeNumber,
        OrientationExpDate: this.item.OrientationExpDate,
        isPermittedToUnload: this.item.isPermittedToUnload,
        isActive: this.item.isActive,
        LockedOut: this.item.LockedOut,
        Comments: this.item.Comments,
        DriverID: this.drvID
      };
      console.log(parms);
      var str = this.$store;
      str.state.isLoading = true;
      axios
        .post('driver-badge', parms, {
          headers: {
            Authorization: 'Bearer ' + this.$store.state.token
          }
        })
        .then(response => {
          console.log(response);
          str.state.isLoading = false;
          str.dispatch('setSnackbar', {
            color: 'success',
            text: 'Bagde saved successfully'
          });
          this.$store.state.BadgeCred.watch = true;
          this.$store.state.badge.dialog = false;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status === 403) {
            str.dispatch('setSnackbar', {
              color: 'error',
              text:
                'You do not have the permission to use this function.'
            });
            str.state.isLoading = false;
          }
          if (error.response.status === 500) {
            str.dispatch('setSnackbar', {
              color: 'error',
              text: 'An error has ocurred, please try again.'
            });
            str.state.isLoading = false;
          }
        });
    },
    validate() {
      if (this.$refs.form.validate() == false) {
        this.$refs.form.validate();
      } else {
        this.newBadges();
      }
    },
    loadTerminals: function (terms) {
      axios
        .get('terminal', {
          headers: {
            Authorization: 'Bearer ' + this.$store.state.token
          }
        })
        .then(response => {
          this.terminals = response.data.data;
          var idTerm = '';
          terms.forEach(elem => {
            idTerm = this.terminals.findIndex(idx => {
              return elem == idx.id;
            });
            this.terminals.splice(idTerm, 1);
          });

          for (var i = 0; i < this.terminals.length; i++) {
            if (this.terminals[i].Active == 0) {
              this.terminals[i].Status =
                this.terminals[i].Name + ' - ' + 'Not Active';
            } else {
              this.terminals[i].Status =
                this.terminals[i].Name + ' - ' + 'Active';
            }
          }

          console.log(this.terminals);

          this.dataLoading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
      this.$store.state.isLoading = false;
    }
  }
};
</script>

<style></style>
